import { render, staticRenderFns } from "./BookUserStateBadge.vue?vue&type=template&id=f1135160&scoped=true&"
import script from "./BookUserStateBadge.vue?vue&type=script&lang=js&"
export * from "./BookUserStateBadge.vue?vue&type=script&lang=js&"
import style0 from "./BookUserStateBadge.vue?vue&type=style&index=0&id=f1135160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1135160",
  null
  
)

export default component.exports